module.exports = __webpack_public_path__ + "img/mazda.012dc7e1.svg";